import React, { Component } from 'react';
import { Button, Select, Table, message, Pagination } from "antd";
import { Image as Images } from "../Images";
import { getInvoice } from '../../Controller/API/ProjectAPI';
import { ProjectDetailHead } from './ProjectDetailHead';
import moment from "moment";

const { Option } = Select;

function handleChange(value) {
    console.log(`selected ${value}`);
}

const pagination = Pagination;
pagination.pageSize = 10;

class ProjectInvoiceInner extends Component {
    state = {
        invoices: [],
        pagination: pagination,
        loading: true,
        count: 0
    };
    columns = [
        {
            title: <div>Invoice</div>,
            dataIndex: 'project',
            render: (project) => <div className="d-flex align-items-center">
                <span className="icon-img">
                    <img alt="folder web icon" src={Images.invoice_icon} />
                </span>
                <div className="text-div-inn">
                    {project}
                </div>
            </div>
        },
        {
            title: <div className="d-flex align-items-center align-items-center">Date Created <img
                src={Images.arrow_down} alt="arrow down" className="img-fluid ml-1" /></div>,
            dataIndex: 'created',
            render: (data) => moment(data).format("ll")
        },
        {
            title: 'Due Date',
            p: 'due_date',
            render: (data) => moment(data).format("ll")
        }, {

            title: 'Open Balance',
            dataIndex: 'open_balance',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: text => <div>
                <Button className="text-uppercase danger-btn-error">{text}</Button>
                {/*<Button className="text-uppercase progress-btn-yellow">25.4% Paid</Button>*/}
                {/*<Button className="text-uppercase success-btn-green">Paid in full</Button>*/}
            </div>,
        },
    ];

    componentDidMount() {
        this.fetch()
    }
    shouldComponentUpdate(nextProps, nextState) {
        return true
    }

    fetch = (params = {}) => {
        let payload = { project: this.props.serviceDetail.id, ...params };
        getInvoice(payload).then((response) => {
            let { pagination } = this.state;
            pagination.total = response.data.count;
            this.props.count(response.data.count)
            this.setState({ count: response.data.count, invoices: response.data.results, pagination, loading: false })
        }).catch((err) => {
            if (err.response) {
                Object.keys(err.response.data).map((i) => {
                    message.error(err.response.data[i])
                })
            } else {
                message.error("something went wrong")
            }
        })
    };

    handleChange = (pagination, filters, sorter) => {
        let { params } = this.state;
        let symbol = sorter.order === 'descend' ? '-' : '';
        params = { ...params, page: pagination.current, ordering: `${symbol}${sorter.columnKey}` };
        this.setState({ params });
        this.fetch(params)
    };

    render() {
        const { invoices, pagination, loading, count } = this.state;
        const { serviceDetail } = this.props;
        return (
            <React.Fragment>
                <div className="col-12">
                    <div className="row em-service-table-card bg-transparent shadow-none em-table-invoices-card">
                        <div className="col-12 p-0">
                            <div className="row billing-info-row-heading justify-content-between">
                                <ProjectDetailHead serviceDetail={serviceDetail} content={count > 0 && `${count} Invoice`} />
                                <div className="all-invoice-select">
                                    <Select placeholder="All Invoice" onChange={handleChange}>
                                        <Option value="jack">All Invoice</Option>
                                        <Option value="lucy">All Invoice</Option>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row em-service-table-card em-table-invoices-card">
                                <div className="col-12 p-0">
                                    <Table
                                        loading={loading}
                                        className="table-responsive em-service-table"
                                        columns={this.columns}
                                        onChange={this.handleChange}
                                        dataSource={invoices}
                                        pagination={{ ...pagination }}
                                        size="middle"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ProjectInvoiceInner;